<script setup lang="ts">
import Translator from "@/utils/common/Translator.ts";
import DTOVueGUITheme = namaTypes.DTOVueGUITheme;

const props = withDefaults(defineProps<{ theme: DTOVueGUITheme, active: boolean, shownInUserMenu?: boolean }>(),
  {shownInUserMenu: undefined});
const emit = defineEmits<{ (e: 'apply'): void, (e: 'toggleShowInUserMenu'): void }>();

const hasUserMenuToggle = props.shownInUserMenu !== undefined;
</script>

<template>
  <div
    tabindex="0"
    @click="emit('apply')"
    @keydown.enter.prevent="emit('apply')"
    @keydown.space.prevent="emit('apply')"
    class="tw-relative tw-cursor-pointer tw-select-none tw-rounded-lg tw-p-3 tw-outline-none tw-transition-colors
           focus-visible:tw-ring-2 focus-visible:tw-ring-primary-light dark:focus-visible:tw-ring-primary-dark"
    :class="active
      ? 'tw-border-2 tw-border-primary-light dark:tw-border-primary-dark'
      : 'tw-border tw-border-gray-200 dark:tw-border-gray-700 hover:tw-border-gray-300 dark:hover:tw-border-gray-600'">
    <div class="tw-flex tw-h-7 tw-overflow-hidden tw-rounded-md tw-border tw-border-gray-200 dark:tw-border-gray-700">
      <span class="tw-flex-1" :style="{backgroundColor: theme.lightColorTheme?.primaryColor}"/>
      <span class="tw-flex-1" :style="{backgroundColor: theme.lightColorTheme?.primaryBackgroundColor}"/>
      <span class="tw-flex-1" :style="{backgroundColor: theme.darkColorTheme?.primaryColor}"/>
      <span class="tw-flex-1" :style="{backgroundColor: theme.darkColorTheme?.primaryBackgroundColor}"/>
    </div>
    <div class="tw-mt-2 tw-flex tw-items-center tw-gap-2">
      <span class="tw-flex-1 tw-truncate tw-text-sm tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark"
            v-text="Translator.getName(theme.name1 ?? '', theme.name2 ?? '')"/>
      <span v-if="active"
            class="tw-shrink-0 tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-text-primary-light dark:tw-text-primary-dark
                   tw-bg-[rgb(var(--nama-primary-light)/0.12)] dark:tw-bg-[rgb(var(--nama-primary-dark)/0.2)]"
            v-text="Translator.translateId('active')"/>
      <button v-if="hasUserMenuToggle"
              type="button"
              :title="Translator.translateId(shownInUserMenu ? 'hideFromUserMenu' : 'showInUserMenu')"
              :aria-label="Translator.translateId(shownInUserMenu ? 'hideFromUserMenu' : 'showInUserMenu')"
              class="tw-flex tw-shrink-0 tw-items-center tw-rounded-full tw-p-0.5
                     tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark
                     focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-primary-light
                     dark:focus-visible:tw-ring-primary-dark"
              :class="{'tw-opacity-50': !shownInUserMenu}"
              @click.stop="emit('toggleShowInUserMenu')"
              @keydown.enter.stop
              @keydown.space.stop>
        <q-icon :name="shownInUserMenu ? 'visibility' : 'visibility_off'" size="18px"/>
      </button>
    </div>
  </div>
</template>
